<template>
  <div class="dashboard">
    <div class="w-full flex">
      <div class="w-full max-w-xs mdmax:w-full mb-6">
        <!-- <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Rentang Tanggal</label> -->
        <div class="date-range relative text-xs shadow-sm">
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2 z-1">
            <Calendar color="neutral-700" />
          </div>
          <date-range-picker v-model="dateRange" :locale-data="{ format: 'dd/mm/yyyy', separator: ' - ' }"
            @update="setDate" :showDropdowns="false" :timePicker="false" :timePicker24Hour="false"
            :ranges="false"></date-range-picker>
        </div>
      </div>
    </div>

    <div class="flex justify-between items-center gap-6 mb-6 mdmax:flex-wrap mdmax:gap-2">
      <router-link to="/order" title="Klik untuk melihat selengkapnya"
        class="flex-1 p-5 mdmax:p-4 bg-primary-600 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md">
        <div>
          <p class="text-white mdmax:text-sm">{{ $t('dashboard.totalDelivery') }}</p>
          <p class="text-lg font-bold text-white">{{ totalOrders?.total_delivery?.total }}</p>
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100">
          <Courier color="neutral-700" height="18" width="18" />
        </span>
      </router-link>
      <router-link title="Klik untuk melihat selengkapnya"
        to="/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=ONGOING&sort=DESC"
        class="flex-1 p-5 mdmax:p-4 bg-primary-600 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md">
        <div class="">
          <p class="text-white mdmax:text-sm">{{ $t('dashboard.totalProcessed') }}</p>
          <p class="text-lg font-bold text-white">{{ totalOrders?.total_proceed?.total }}</p>
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100">
          <Truck color="neutral-700" height="15" width="19" />
        </span>
      </router-link>
      <router-link title="Klik untuk melihat selengkapnya"
        to="/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=COMPLETED&sort=DESC"
        class="flex-1 p-5 mdmax:p-4 bg-primary-600 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md">
        <div class="">
          <p class="text-white mdmax:text-sm">{{ $t('dashboard.totalDelivered') }}</p>
          <p class="text-lg font-bold text-white">{{ totalOrders?.total_delivered?.total }}</p>
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100">
          <Delivered color="neutral-700" height="20" width="19" />
        </span>
      </router-link>
      <router-link title="Klik untuk melihat selengkapnya"
        to="/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=COMPLAIN&sort=DESC"
        class="flex-1 p-5 mdmax:p-4 bg-primary-600 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md">
        <div class="">
          <p class="text-white mdmax:text-sm">{{ $t('dashboard.totalFailed') }}</p>
          <p class="text-lg font-bold text-white">{{ totalOrders?.total_failed?.total }}</p>
        </div>
        <span class="flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100">
          <Undelivered color="neutral-700" height="20" width="19" />
        </span>
      </router-link>
    </div>
    <div class="flex items-start gap-6 mb-6 mdmax:flex-col">
      <div class="w-2/6 px-3 py-4 bg-white mdmax:order-2 mdmax:w-full shadow-md">
        <div class="">
          <p class="text-lg font-bold mb-4">{{ $t('dashboard.successOrder.title') }}</p>
          <template v-if="!logisticReady">
            <div class="h-40 flex items-center justify-center">
              <img src="@/assets/images/rolling.gif" />
            </div>
          </template>
          <template v-else>
            <TableComponent compact :columns="columnsSuccess" :list="logisticOrders?.top_success_delivery">
              <template slot="table-row" slot-scope="{ entry, column, index }">
                <span class="block text-center" v-if="column.field === 'no'">{{ index + 1 }}</span>
                <span class="flex justify-center text-center" v-else-if="column.field === 'logo'">
                  <img :src="entry.logo" class="w-16" v-if="entry.logo" />
                  <LogisticPlaceholder :logisticName="entry.name" v-else />
                </span>
                <span v-else class="block text-center">{{ entry[column.field] || '0' }}</span>
              </template>
            </TableComponent>
          </template>
        </div>
        <div class="my-6">
          <p class="text-lg font-bold mb-4">{{ $t('dashboard.failedOrder.title') }}</p>
          <template v-if="!logisticReady">
            <div class="h-40 flex items-center justify-center">
              <img src="@/assets/images/rolling.gif" />
            </div>
          </template>
          <template v-else>
            <TableComponent compact :columns="columnsFailed" :list="logisticOrders?.top_failed_delivery">
              <template slot="table-row" slot-scope="{ entry, column, index }">
                <span class="block text-center" v-if="column.field === 'no'">{{ index + 1 }}</span>
                <span class="flex justify-center text-center" v-else-if="column.field === 'logo'">
                  <img :src="entry.logo" class="w-16" v-if="entry.logo" />
                  <LogisticPlaceholder :logisticName="entry.name" v-else />
                </span>
                <span v-else class="block text-center">{{ entry[column.field] || '0' }}</span>
              </template>
            </TableComponent>
          </template>
        </div>
      </div>
      <div class="w-4/6 mdmax:order-1 mdmax:w-full">
        <div class="mb-6 px-3 py-4 bg-white shadow-md">
          <p class="text-lg font-bold mb-4">{{ $t('dashboard.shippingCost') }}</p>
          <!-- <LineChart :data="lineChartData" :options="lineChartOption" /> -->
          <div class="flex items-center gap-6 mdmax:flex-col">
            <div class="flex-1 flex justify-center items-center">
              <div class="w-60">
                <PieChart :data="chartData" :options="chartOptions" v-if="isExpenseReady" />
              </div>
            </div>
            <div class="flex-1 flex-col flex justify-center gap-6">
              <div class="flex items-center gap-4">
                <div class="w-10 h-5 bg-primary-500"></div>
                <div>
                  <p class="text-xs text-neutral-500 mb-0.5">Bulan Ini</p>
                  <p class="text-sm text-neutral-700">{{ expenses.current | currencyFormat }}</p>
                </div>
              </div>
              <div class="flex items-center gap-4">
                <div class="w-10 h-5 bg-secondary-500"></div>
                <div>
                  <p class="text-xs text-neutral-500 mb-0.5">Bulan Lalu</p>
                  <p class="text-sm text-neutral-700">{{ expenses.previous | currencyFormat }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="px-3 py-4 bg-white shadow-md">
          <div class="flex justify-between items-center mb-4">
            <p class="text-lg font-bold">{{ $t('dashboard.onGoingDeliveries.title') }}</p>
            <router-link to="/order" class="inline-block text-primary-500 font-medium mdmax:text-sm ">
              {{ $t('dashboard.seeAll') }}
            </router-link>
          </div>
          <TableComponent compact :columns="orderColumns" :list="filteredData">
            <template slot="table-row" slot-scope="{ entry, column }">
              <span class="block" v-if="column.field === 'created_time'">{{ entry.created_time | formatDate }}</span>
              <div class="block" v-else-if="column.field === 'sender_location'">
                <p>{{ entry.pickup_address }}</p>
                <p class="text-xs text-neutral-500 mt-1" v-if="entry.pickup_detail">{{ entry.pickup_detail }}</p>
              </div>
              <div class="block" v-else-if="column.field === 'receiver_location'">
                <p>{{ entry.destination_address }}</p>
                <p class="text-xs text-neutral-500 mt-1" v-if="entry.destination_detail">{{ entry.destination_detail }}
                </p>
              </div>
              <span v-else>{{ entry[column.field] }}</span>
            </template>
          </TableComponent>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate, currencyFormat } from '@/util'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import dayjs from 'dayjs'
const NOW = new Date()

export default {
  filters: {
    formatDate,
    currencyFormat
  },
  components: {
    DateRangePicker,
    Calendar: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Calendar'),
    Courier: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Courier'),
    Truck: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Truck'),
    // Order: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Order'),
    Delivered: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Delivered'),
    Undelivered: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Undelivered'),
    // LineChart: () => import(/* webpackChunkName: "chart" */ '@/components/Chart/LineChart'),
    PieChart: () => import(/* webpackChunkName: "chart" */ '@/components/Chart/PieChart'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    LogisticPlaceholder: () => import(/* webpackChunkName: "LogisticPlaceholder" */ '@/components/Icons/LogisticPlaceholder')
  },
  data: () => ({
    // lineChartData: {
    //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    //   datasets: [
    //     {
    //       label: 'Pendapatan',
    //       backgroundColor: 'transparent',
    //       borderColor: '#59c8c1',
    //       data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
    //     }
    //   ]
    // },
    // lineChartOption: { responsive: true, maintainAspectRatio: false },
    shippingCost: {
      currentMonth: 1000000,
      lastMonth: 1000000
    },
    columnsShipping: [
      { label: 'Tgl', field: 'order_delivery_schedule' },
      { label: 'Order Book', field: 'order_booking_code' },
      { label: 'Pengirim', field: 'sender' },
      { label: 'Lokasi Pengirim', field: 'senderLocation' },
      { label: 'Penerima', field: 'receiver' },
      { label: 'Lokasi Penerima', field: 'receiverLocation' }
    ],
    queries: {
      page: 1,
      per_page: 8,
      search_keyword: '',
      start_date: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      status: 'ONGOING',
      sort: 'DESC'
    },
    dataIsReady: false,
    successLogistic: [],
    failedLogistic: [],
    logisticReady: false,
    isExpenseReady: false,
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 7),
      endDate: NOW
    },
  }),
  computed: {
    ...mapGetters('order', ['orderList']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('summary', ['totalOrders', 'logisticOrders', 'expenses']),
    filteredData() {
      let temp = this.orderList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    partnerId() {
      return this.userData?.user?.group_id
    },
    currentMonthShippingCost() {
      return this.shippingCost.currentMonth
    },
    lastMonthShippingCost() {
      return this.shippingCost.lastMonth
    },
    chartOptions() {
      return {
        hoverBorderWidth: 20,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    },
    chartData() {
      return {
        hoverBackgroundColor: 'red',
        hoverBorderWidth: 10,
        labels: [this.$t('dashboard.thisMonth'), this.$t('dashboard.lastMonth')],
        datasets: [
          {
            label: this.$t('dashboard.shippingCost'),
            backgroundColor: ['#59C8C1', '#637CFF'],
            data: [this.expenses.current, this.expenses.previous]
          }
        ]
      }
    },
    columnsSuccess() {
      return [
        { label: 'No', field: 'no', center: true },
        { label: this.$t('dashboard.successOrder.logistic'), field: 'logo', center: true },
        { label: this.$t('dashboard.successOrder.delivered'), field: 'total', center: true }
      ];
    },
    columnsFailed() {
      return [
        { label: 'No', field: 'no', center: true },
        { label: this.$t('dashboard.failedOrder.logistic'), field: 'logo', center: true },
        { label: this.$t('dashboard.failedOrder.undelivered'), field: 'total', center: true }
      ];
    },
    orderColumns() {
      return [
        { label: this.$t('dashboard.onGoingDeliveries.date'), field: 'created_time' },
        { label: this.$t('dashboard.onGoingDeliveries.sender'), field: 'sender_name' },
        { label: this.$t('dashboard.onGoingDeliveries.senderLocation'), field: 'sender_location' },
        { label: this.$t('dashboard.onGoingDeliveries.receiver'), field: 'receiver_name' },
        { label: this.$t('dashboard.onGoingDeliveries.receiverLocation'), field: 'receiver_location' }
      ];
    },
  },
  created() {
    if (Object.keys(this.$route.query).length === 0) {
      this.$router.replace({ path: '/dashboard', query: this.queries })
    }

    this.getOrderList()
    this.getSummary()

    this.logisticReady = false
    this.getLogisticOrders().then(() => {
      this.logisticReady = true
    })

    this.isExpenseReady = false
    this.getExpenses().then(() => {
      this.isExpenseReady = true
    })
  },
  methods: {
    ...mapActions('order', ['getOrders']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('summary', ['getTotalOrders', 'getLogisticOrders', 'getExpenses']),
    getAreaName(code) {
      return this.cities?.filter(item => item.code === code)[0]?.name
    },
    getOrderList() {
      this.showLoading()
      this.getOrders({
        params: this.queries
      })
        .then(res => {
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('error', error.response)
        })
    },
    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key]
        var y = b[key]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    setDate(value) {
      const newStart = dayjs(value.startDate).format('YYYY-MM-DD')
      const newEnd = dayjs(value.endDate).format('YYYY-MM-DD')

      if (this.queries.start_date !== newStart || this.queries.end_date !== newEnd) {
        this.queries.start_date = newStart
        this.queries.end_date = newEnd
        this.$router.replace({ query: { ...this.queries } })
      }
    },
    getSummary() {
      const { start_date, end_date } = this.queries

      // Set loading flags before request
      this.logisticReady = false
      this.isExpenseReady = false

      const logistic = this.getLogisticOrders({ params: { start_date, end_date } }).then(() => {
        this.logisticReady = true
      })

      const expenses = this.getExpenses({ params: { start_date, end_date } }).then(() => {
        this.isExpenseReady = true
      })

      const total = this.getTotalOrders({ params: { start_date, end_date } })

      // Await all (optional)
      Promise.all([logistic, expenses, total]).catch(error => {
        console.error('getSummary error:', error.response || error)
      })
    }
  },
  watch: {
    '$route.query': {
      handler(val) {
        console.log('val', this.queries)
        this.queries = { ...this.queries, ...val }
        this.getOrderList()
        this.getSummary()
      },
      immediate: true, // optional if you want this to run on initial mount
      deep: true // optional depending on if you care about nested values
    }
  }
}
</script>
<style lang="scss" scoped>
.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
  }

  &::v-deep .vue-daterange-picker {
    display: block;
  }
}
</style>
